import { dataExclamationCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExclamationCircle = /*#__PURE__*/createIcon(dataExclamationCircle)
export default IconExclamationCircle
